module.exports = __webpack_public_path__ + "img/tpc-39.2e72a0c0.webp";